import { defineRoutes } from '#utils';

export const routes = defineRoutes({
  users: {
    find: '/users',
    get: (id: string) => `/users/${id}`,
    patch: (id: string) => `/users/${id}`,
  },
});
